import {
  getProcess,
  getSupportedProcessesInfo,
  INQUIRY_PROCESS_NAME,
  isBookingProcess,
  resolveLatestProcessName,
} from '../../transactions/transaction';

const bookingProcess = getProcess('default-booking');

// These states can only be reached after the provider has accepted the booking.
// Canceled is intentionally included: in the booking graph it is downstream of accepted,
// so it represents a real booking that was subsequently canceled.
export const YOUR_BOOKINGS_STATE_NAMES = [
  bookingProcess.states.ACCEPTED,
  bookingProcess.states.CANCELED,
  bookingProcess.states.DELIVERED,
  bookingProcess.states.REVIEWED,
  bookingProcess.states.REVIEWED_BY_CUSTOMER,
  bookingProcess.states.REVIEWED_BY_PROVIDER,
];

export const YOUR_BOOKINGS_API_STATES = YOUR_BOOKINGS_STATE_NAMES.map(state =>
  state === bookingProcess.states.CANCELED ? 'state/cancelled' : `state/${state}`
).concat('state/booked'); // Keep already-converted transactions from the superseded dead-end version visible.

export const YOUR_BOOKINGS_PROCESS_NAMES = getSupportedProcessesInfo()
  .filter(
    processInfo => isBookingProcess(processInfo.name) || processInfo.name === INQUIRY_PROCESS_NAME
  )
  .map(processInfo => processInfo.name);

const yourBookingsStateSet = new Set(YOUR_BOOKINGS_STATE_NAMES);

export const isActualBookingTransaction = transaction => {
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  const isConvertedInquiry = processName === INQUIRY_PROCESS_NAME;
  if (!isBookingProcess(processName) && !isConvertedInquiry) {
    return false;
  }

  try {
    const state = getProcess(processName).getState(transaction);
    return yourBookingsStateSet.has(state) && (!isConvertedInquiry || !!transaction?.booking);
  } catch (error) {
    return false;
  }
};
